import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentSetContentFormComponent } from './components/content-set-content-form/content-set-content-form.component';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: ContentSetContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.CONTENT_SET, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: ContentSetContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.CONTENT_SET, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: ContentSetContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.CONTENT_SET, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentSetContentRoutingModule {}
